import { SpoolDto } from '../../../../../../../types/spool-local';
import { useContext } from 'react';
import { IncentivizedArrowIcon } from '../../../../../../assets/icons';
import Button from '../../../../../../components/Button';
import HighlightText from '../../../../../../components/HighlightText';
import spoolsContext from '../../../../../../context/spools/spoolsContext';
import {
    formatAmountWithSuffix,
    formatPercentages,
} from '../../../../../../helpers/formats';
import AdjustedApy from '../../../../../../modals/infoPopUp/AdjustedApy';
import IncentivizeReward from '../../../../../../modals/infoPopUp/IncentivizeReward';

type Props = {
    spoolDetails: SpoolDto;
    toggle: () => void;
};

const SpoolCreatorFeesAccordionRow: React.FC<Props> = ({ spoolDetails, toggle }) => {
    const {
        address,
        adjustedApy,
        baseApy,
        incentivizedRewards,
        performanceFees,
        name,
        tvr,
        ownerFeesCollectedAmount,
    } = spoolDetails;

    const { searchTerm } = useContext(spoolsContext);

    return (
        <div className='row-container' onClick={toggle}>
            <div>
                <div className='arrow-container'>
                    <div className='arrow' />
                </div>
                {searchTerm ? (
                    <HighlightText text={name} highlight={searchTerm} />
                ) : (
                    <span>{name}</span>
                )}
            </div>
            <div className='apy'>
                <span className='column-label'>APY</span>
                <div>
                    <IncentivizeReward
                        icon={
                            <IncentivizedArrowIcon
                                incentivized={!!incentivizedRewards?.length}
                            />
                        }
                        incentivizedRewards={incentivizedRewards}
                    />
                    {formatPercentages(parseFloat(adjustedApy) * 100 || 0)}%
                    <AdjustedApy
                        adjustedApy={adjustedApy}
                        baseApy={baseApy}
                        incentivizedRewards={incentivizedRewards}
                        performanceFees={performanceFees}
                    />
                </div>
            </div>
            <div>
                <span className='column-label'>TVR</span>
                {tvr === '0' ? 'N/A' : `${formatAmountWithSuffix(tvr || 0)}`}
            </div>
            <div>
                <span className='column-label'>Earned Fees</span>$
                {ownerFeesCollectedAmount}
            </div>
            <div>
                <Button interalLink={`/app/spool/${address}`}>View Spool</Button>
            </div>
        </div>
    );
};

export default SpoolCreatorFeesAccordionRow;
